import { LocalStorageService } from "@/Services/LocalStorageService";

import { LocalStorageNamespace } from "../Models/Localstorage/LocalStorageNamespace";

import { isApp } from "@/Utils/Ionic";
import { hasValue } from "@/Utils/Objects";

class IsNeededPreviewActionHandler {
  constructor(
    private readonly previewLocalStotage: LocalStorageService = new LocalStorageService(
      LocalStorageNamespace.PREVIEW
    )
  ) {}

  public handle(): boolean {
    if (isApp()) {
      return !hasValue(this.previewLocalStotage.get("date"));
    }

    return false;
  }
}

export default IsNeededPreviewActionHandler;
